import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Menu',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { width: "24", height: "18", viewBox: "0 0 24 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }
      }, ctx.data]),
      [h("path", {
        attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M0 1.5a1 1 0 011-1h22a1 1 0 110 2H1a1 1 0 01-1-1zm0 7a1 1 0 011-1h22a1 1 0 110 2H1a1 1 0 01-1-1zm1 6a1 1 0 100 2h22a1 1 0 100-2H1z", fill: "currentColor" }
      })]
    );
  }
};